const a = {
  "search-input": "search-input",
  "search-input__label": "search-input__label",
  "search-input__description": "search-input__description",
  "search-input__input": "search-input__input",
  "search-input__search-icon": "search-input__search-icon",
  "search-input__clear-icon": "search-input__clear-icon",
  "search-input--auto-width": "search-input--auto-width",
  "search-input--small": "search-input--small"
};
export {
  a as default
};
